<template>
    <div>
    <v-snackbar v-model="msg" top> {{ text }} <v-btn color="pink" text  @click="msg = false"> Close</v-btn></v-snackbar>
   <ClientNav/>
  <v-card>
    <v-card-title style="background-color: #2b3990">
      <span class="headline white--text">{{ titleForm  }}</span>
    </v-card-title>
    <v-card-text>
      <v-container>
        <v-row>
          <v-col cols="12" sm="12" md="4">
              <v-menu
              ref="menu"
              v-model="menu"
              :close-on-content-click="true"
              :return-value.sync="date"
              transition="scale-transition"
              offset-y
              min-width="auto"
          >
              <template v-slot:activator="{ on, attrs }">
              <v-text-field
                  v-model="newDate"
                  label="Date"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
              ></v-text-field>
              </template>
              <v-date-picker
              v-model="newDate"
              no-title
              scrollable
              >
              </v-date-picker>
          </v-menu>
          </v-col>
          <v-col cols="12" sm="12" md="4">
              <v-text-field
                  prepend-icon="schedule"
                  label="Time"
                  v-model="time"
              ></v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="4">
            <v-text-field
              label="Who Contacted"
              v-model="contacted"
          ></v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="6">
            <v-text-field
              label="Specify"
              v-model="specify"
          ></v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="6">
            <v-select
              label="Note Type"
              :items="notes"
              v-model="noteType"
          ></v-select>
          </v-col>
          <v-col cols="12" sm="12">
            <v-textarea
              label="Communication Notes"
              v-model="communicationNotes"
              outlined
          ></v-textarea>
          </v-col>
          <v-col cols="12" sm="12" md="6">
            <v-select
              :items="commType"
              v-model="communicationType"
              label="Communications Type"
          ></v-select>
          </v-col>
          <v-col cols="12" sm="12" md="6">
            <v-text-field
              v-model="createdBy"
              label="Created By"
              readonly
            ></v-text-field>
          </v-col>
          <v-col cols="12">
              <v-file-input   
                v-model="newDocument"                             
                class="pa-2"
                label="Select documents to upload"
                show-size
                filled
                multiple
                prepend-icon="mdi-camera"
                accept="image/*,.pdf,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                @change="fileSelected"
              >
                <template #selection="{ text, index }">
                  <v-chip small label close color="primary" @click:close="deleteChip(index)">{{ text }}</v-chip>
                </template>
              </v-file-input>
            </v-col>
            <v-col cols="12" sm="12" md="3" 
                v-for="document in newDocument" :key="document.url"
              >
              <template v-if="document.type === 'pdf'">
                <LoadPDF :pdfFile="document.url" :pdfName="document.name"/>
              </template>
              <template v-else-if="['jpg', 'jpeg', 'png', 'JPG', 'PNG', 'JPEG'].includes(document.type)">
                <v-img max-height="320" max-width="240" :src="document.url" />
              </template>
            </v-col>
            <v-col cols="12" sm="12">
              <v-file-input
                  chips
                  show-size
                  class="pa-2"
                  label="Select videos to upload"
                  filled
                  multiple
                  prepend-icon="mdi-play-circle-outline"
                  accept="video/mp4,video/x-m4v,video/*"
                  @change="selectCommunicationLogVideos"
              ></v-file-input>
            </v-col>
            <v-col cols="12" sm="12">
              <div
                  v-for="communicationLogVideoUrl in selectedCommunicationLog.CommunicationLogVideos"
                  :key="communicationLogVideoUrl"
              >
                  <video width="320" height="240" controls>
                      <source :src="communicationLogVideoUrl" type="video/mp4">
                      <source :src="communicationLogVideoUrl" type="video/ogg">
                      Your browser does not support the
                      tag.
                  </video>
              </div>
            </v-col>
            <v-col cols="12" sm="12">
              <v-file-input
                  chips
                  show-size
                  class="pa-2"
                  label="Select audio to upload"
                  filled
                  prepend-icon="mic"
                  accept="audio/*"
                  v-model="showAudioFile"
                  @change="handleFileChange($event)"
              ></v-file-input>
            </v-col>
            <v-col cols="12" v-if="showAudioFile">
              <audio ref="audioPlayer" controls>
              <source :src="showAudioFile" type="audio/mpeg">
              Your browser does not support the audio element.
            </audio>
            </v-col>
            <v-col cols="12" sm="12">
              <audio-recorder @recording-finished="handleRecording" ref="audioRecorderForm" />
            </v-col>
        </v-row>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="#259647" 
        class="white--text" 
        @click="addCommunication()" 
        v-if="newLog"
      >
        Save
      </v-btn>
      <v-btn color="#259647" class="white--text" @click="updateCommunication()" v-if="!newLog">Update</v-btn
      >
      <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
    </v-card-actions>
  </v-card>
  </div>
</template>
<script>
import LoadPDF from '@/components/LoadPDF.vue';
import AudioRecorder from '@/components/AudioRecorder.vue';
import ClientNav from '@/components/ClientNav';
import axios from 'axios';
// import router if needed
// import router from '../router';

const url = require("@/client_config/config").url;

export default {
  components: {
    LoadPDF,
    AudioRecorder,
    ClientNav
  },
  data() {
    return {
      titleForm: '',
      menu: false,
      date: null,
      newDate: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      time: '',
      contacted: '',
      specify: '',
      notes: [
        "Admissions",
        "AMA",
        "Clinical Team Meeting",
        "Dietitian",
        "Discharge",
        "Education",
        "Family Therapy",
        "General",
        "Group Therapy",
        "Nursing",
        "Phase Coordinator",
        "Progress",
        "Recreational Therapy",
        "Relapse",
        "Residential Advisor",
        "Services",
        "Staff Shift Change",
        "Utilization Review",
        "Warnings",
        "Other"
      ],
      noteType: '',
      communicationNotes: '',
      commType: [
        "Family",
        "Legal",
        "Referent",
        "Other"
      ],
      communicationType: '',
      createdBy: localStorage.getItem('Name'),
      newDocument: [],
      selectedCommunicationLog: {
        CommunicationLogVideos: []
      },
      showAudioFile: null,
      newLog: this.$route.params.communicationID ? false : true,
      newCommunicationLogVideo: '',
      communicationID: '',
      uploadFile: '',
      communicationLogVideos: [],
      selectedFile: null,
      clientID: this.$route.params.clientID,
      msg: false,
      text: '',
      isLoading: false,
      uploadedFiles: [],
      uploadedAudio: "",
      uploadedVideos: [],
      videos: ""
    };
  },
  methods: {
    async addCommunication() {
      this.createdBy = localStorage.getItem('Name');
      var req_body = {
        Date: this.newDate,
        Time: this.time,
        Contacted: this.contacted,
        Specify: this.specify,
        NoteType: this.noteType,
        Notes: this.communicationNotes,
        CommType: this.communicationType,
        CreatedBy: this.createdBy,
        CommunicationLogVideo: this.newCommunicationLogVideo,
        ClientID: this.clientID,
      };
      
      if (this.uploadFile !== null && this.uploadFile !== undefined && this.uploadFile?.length > 0) {
        this.uploadedFiles = await Promise.all(
          this.uploadFile.map(async (file) => {
              return this.uploadFiles(file);
          })
        )
      }

      if (this.selectedFile) {
        this.uploadedAudio = await this.uploadAudio();
      }

      if (this.communicationLogVideos && this.communicationLogVideos?.length > 0) {
        this.uploadedVideos = await Promise.all(this.communicationLogVideos.map(async (file) => {
            return this.uploadFiles(file);
          }));
      }
      req_body.CommunicationAudio = this.uploadedAudio.AWSLink ?? "";
      req_body.CommunicationLogVideo = this.uploadedVideos?.map(video => video.AWSLink).join(',') ?? "";
        
      axios.post(`${url}/communications`, req_body ).then(async(res) => {
        if (res.status == 400) {
          res.json().then(function(data) {
            this.text=data.msg;
          });
        }
        this.msg =true;
        this.text ="The new communication log has been added successfully.";
        this.communicationID = res.data._id
        await this.assignDocumentToCommunication(this.uploadedFiles);
        await this.assignDocumentToCommunication(this.uploadedAudio ? [this.uploadedAudio] : []);
        await this.assignDocumentToCommunication(this.uploadedVideos);
        setTimeout(this.close(), 2000);

      });
    },
    async updateCommunication() {
      var req_body = {
        Date: this.newDate,
        Time: this.time,
        Contacted: this.contacted,
        Specify: this.specify,
        NoteType: this.noteType,
        Notes: this.communicationNotes,
        Commtype: this.communicationType,
        CommunicationLogVideo: this.newCommunicationLogVideo,
      };
      await this.processAttachments();
      req_body.CommunicationAudio = this.uploadedAudio.AWSLink ?? this.showAudioFile ?? "";
      req_body.CommunicationLogVideo = this.getUpdatedVideoUrls();
      
      axios.put(`${url}/communications/${this.communicationID}`, req_body).then(async(response) => {
        if (response.status == 400) {
          response.json().then(function(data) {
            alert(data.msg);
          });
        }
        this.msg =true;
        this.text ="The communication log has been updated successfully.";
        await this.assignDocumentToCommunication(this.uploadedFiles);
        await this.assignDocumentToCommunication(this.uploadedAudio ? [this.uploadedAudio] : []);
        await this.assignDocumentToCommunication(this.uploadedVideos);
        setTimeout(this.close(), 2000);
      });
    },
    close() {
      if (this.$refs.audioRecorderForm && this.$refs.audioRecorderForm.resetAudioRecorder) {
        this.$refs.audioRecorderForm.resetAudioRecorder();
      }
      this.clearData();
      this.$router.go(-1);
    },
    clearData() {
      this.newDate= "";
      this.time = "";
      this.contacted = "";
      this.specify = "";
      this.noteType = "";
      this.communicationNotes = "";
      this.communicationType = "";
      this.createdBy = "";
      this.newDocument = [];
      this.newIncidentVideo = "";
      this.showAudioFile = "";
      this.selectedCommunicationLog = {};
    },
    fileSelected(e) {
      this.uploadFile=e;
    },
    async saveFile() {
      this.message = "";
      for (let i = 0; i < this.uploadFile.length; i++) {
        await this.uploadFiles(this.uploadFile[i]);
      }
    },
    deleteChip(index) {
      this.newDocument.splice(index, 1);
    },
    selectCommunicationLogVideos(communicationLogVideos) {
      this.communicationLogVideos = communicationLogVideos;
    },
    async uploadCommunicationLogVideos(files) {
      const formData = new FormData();
      formData.append('communicationId', this.communicationID);
      for (let file of files) {
        formData.append('communicationLogVideos[]', file);
      }
      let config = {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      };
      try {
        await axios.post(`${url}/staffCommunications/video/upload`, formData, config);
      } catch (e) {
        console.log({e});
      }
    },
    handleFileChange(file) {
      this.selectedFile = file;
    },
    handleRecording(blob) {
      const actualMime = blob.type === 'audio/webm' ? 'audio/mp4' : blob.type;
      const file = new File([blob], 'recording.m4a', {
        type: actualMime
      });
      this.selectedFile = file;
    },
    async uploadAudio() {
      return await this.uploadFiles(this.selectedFile);
    },
    async uploadFiles(file) {
      const formData = new FormData();
      formData.append("document", file);
      var ct = { headers: { "content-type": "multipart/form-data" } };
      const uploadedFile = await axios.post(`${url}/documents/fileuploader/client/${this.clientID}/ClientCommunicationLogs`, formData, ct);
      return uploadedFile.data;
    },
    async fetchLogDetails(logId) {
      return await axios.get(`${url}/communications/single/${logId}`);
    },
    async processAttachments() {
      if (this.uploadFile !== null && this.uploadFile !== undefined && this.uploadFile?.length > 0) {
        this.uploadedFiles = await Promise.all(
          this.uploadFile.map(async (file) => {
              return this.uploadFiles(file);
          })
        )
      }

      if (this.selectedFile) {
        this.uploadedAudio = await this.uploadAudio();
      }

      if (this.communicationLogVideos && this.communicationLogVideos?.length > 0) {
        this.uploadedVideos = await Promise.all(this.communicationLogVideos.map(async (file) => {
            return this.uploadFiles(file);
          }));
      }
    },
    async assignDocumentToCommunication(files) {
      await Promise.all(
        files.map(
          async (file) => {
            const response = await axios.put(`${url}/documents/${file._id}`, {
              CategoryID: this.communicationID,
            });
            return response.data;
          }
        )
      );
    },
    getUpdatedVideoUrls(){
      let videoUrl = this.newCommunicationLogVideo ?? "";
      let uploadVideoURLs = "";
      if (this.uploadedVideos && this.uploadedVideos.length > 0) {
        uploadVideoURLs = this.uploadedVideos.map(video => video.AWSLink).join(',');
      }
      if (videoUrl && uploadVideoURLs) {
        return `${videoUrl}, ${uploadVideoURLs}`;
      } else if (videoUrl) {
        return videoUrl;
      } else {
        return uploadVideoURLs;
      }
    }
  },
  async created() {
    if (this.$route.params.communicationID) {
      const response = await this.fetchLogDetails(this.$route.params.communicationID);
      const item = response.data;
      this.communicationID = item._id;
      this.newDate = item.Date;
      this.time = item.Time;
      this.contacted = item.Contacted;
      this.specify = item.Specify;
      this.noteType = item.NoteType;
      this.communicationNotes = item.Notes;
      this.communicationType = item.CommType;
      this.createdBy = item.CreatedBy;
      this.newCommunicationLogVideo = item.CommunicationLogVideo;
      this.selectedCommunicationLog = item;
      this.selectedCommunicationLog.CommunicationLogVideos = item.CommunicationLogVideo ? item?.CommunicationLogVideo?.split(',') : [];
      this.showAudioFile = item.CommunicationAudio || '';
      let documents = [];
      if (item.documents) {
        documents = item.documents && item.documents.length ? item.documents : [item.documents];
      }
      if (documents) {
        // Accept: image/*,.pdf,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document
        const allowedExtensions = [
          'pdf', 'doc', 'docx', 'jpg', 'jpeg', 'png', 'JPG', 'PNG', 'JPEG'
        ];
        this.newDocument = documents.filter(document => {
          const ext = document?.AWSLink?.split('.').pop()?.toLowerCase();
          return allowedExtensions.includes(ext);
        }).map(document => {
          return {
            name: document.Name,
            url: document.AWSLink,
            type: document?.AWSLink?.split('.').pop()
          };
        });
      }
      this.newLog = false;
    }
  },
};
</script>
